import birminghamUni from "../../assets/university-of-birmingham-logo.png";
import bcu from "../../assets/BCU.webp";
import kehs from "../../assets/KEHS.webp";
import istip from "../../assets/ISTIP.webp";
import ScrollAnimation from "react-animate-on-scroll";
import "./clients-banner.css";

const clientLogos = [
  { src: bcu, alt: "Birmingham City University" },
  { src: kehs, alt: "King Edward VI High School for Girls Birmingham" },
  { src: birminghamUni, alt: "University of Birmingham" },
  { src: istip, alt: "Independent Schools Teacher Induction Panel" },
];

export default function ClientsBanner() {
  return (
    <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
      <div className="ae-clients-banner -dark-theme">
        <h2 className="h1 -dark-theme">The Network</h2>
        <div className="ae-clients-gallery">
          {clientLogos.map((logo, index) => (
            <img
              key={index}
              src={logo.src}
              className="ae-client-logo"
              alt={logo.alt}
            />
          ))}
        </div>
      </div>
    </ScrollAnimation>
  );
}
